<app-page-wrapper
  [useHeader]="true"
  [useFooter]="true"
  [useBackBtn]="true"
  [title]="title"
  [subtitle]="subtitle"

>
  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <div class="new-online-credit_step__allowed" *ngIf="application && application.status === 'approved'">
        <div class="new-online-credit_step__allowed-title">Вам одобрен кредит!</div>
        <div class="new-online-credit_step__allowed-info">
          <span>Сумма до: {{ application.approveAmount.toString() || '0' | amount }} ₽</span>
          <span>Срок до: {{ application?.approvePeriod }} месяцев</span>
          <span>Платеж до: {{ application?.approveMonthAmount.toString()  | amount }}₽ в месяц</span>
          <span>{{ application?.approveInsuranceAmount ? 'Со страховой защитой' : 'Без страховой защитой' }}</span>
        </div>
        <div class="new-online-credit_step__allowed-date">Предложение действует до {{ expDateApplication }}</div>
      </div>

      <div class="calculation-form" *ngIf="settings$ | async as setting">
        <div class="form-item">
          <div class="form-group">
            <label class="form-label">
              <span>Сумма кредита <sup>*</sup></span>
              <span>до {{ setting?.maxAmount.toString() | amount }} ₽</span>
            </label>
            <input
                    type="text"
                    class="form-control"
                    [ngModel]="setting.amount"
                    [maskito]="MaskUtilService.amountMask"
                    (blur)="changeAmount($event)"
                    (keypress)="handleKeypress($event, 'amount')"
            >
          </div>
          <ion-range
                  [max]="setting?.maxAmount"
                  [min]="setting?.minAmount"
                  [step]="setting?.amountStep"
                  [ngModel]="setting.amount"
                  [debounce]="50"
                  (ionChange)="changeAmount($event)"
          >
          </ion-range>
        </div>
        <div class="form-item">
          <div class="form-group">
            <label class="form-label">
              <span>Срок кредитования <sup>*</sup></span>
              <span>до {{ setting?.maxPeriod }} месяцев</span>
            </label>
            <input
                    type="number"
                    [min]="'' + setting?.minPeriod"
                    [max]="'' + setting?.maxPeriod"
                    class="form-control"
                    [ngModel]="setting.period"
                    (blur)="changePeriod($event)"
                    (keypress)="handleKeypress($event, 'period')"
            >
          </div>
          <ion-range
                  [max]="setting?.maxPeriod"
                  [min]="setting?.minPeriod"
                  [step]="setting?.periodStep"
                  [ngModel]="setting.period"
                  [debounce]="50"
                  (ionChange)="changePeriod($event)"
          >
          </ion-range>
        </div>
        <div class="form-item mb-16">
          <div class="form-group">
            <label class="form-label">Ежемесячный платеж</label>
            <span class="form-control">{{ setting.monthlyPayment.toString() | amount }} {{ '810' | cardCurrency }} </span>
          </div>
          <div class="form-group">
            <label class="form-label">Процентная ставка</label>
            <span class="form-control">{{ setting.interestRate }} %</span>
          </div>
        </div>
        <div class="form-item">
          <div class="form-group">
            <label class="form-label">Сумма кредита {{ setting.insurance ? 'с учетом страхования' : '' }}</label>
            <span
                    class="form-control">
            {{ (setting.insurance ? setting.amountWithDks.toString() : setting.amountInput.toString()) | amount }}
              {{ '810' | cardCurrency }}
          </span>
          </div>
        </div>
        <div class="form-item" [hidden]="true">
          <app-form-checkbox
                  [ngModel]="setting.insurance"
                  (ngModelChange)="changeInsurance($event)"
                  [option]="agreeInsuranceInfo.title"
                  [textData]="agreeInsuranceInfo.text"
                  [disabled]="isPromotionalApprovedRate"
          >
          </app-form-checkbox>
          <!--        [hidden]="setting.insurance || isPromotionalApprovedRate"-->
          <span class="increment-interest-rate"
                [hidden]="true">Ставка увеличилась на {{ setting.incInterestRateWithoutInsurance }} %</span>
        </div>
        <div class="note">
          *Пример расчета по кредиту носит информационный характер
          и не является публичной офертой
        </div>
        <div class="note note-warning" [hidden]="!showMoreAmountMaxMessage">
          *Кредит свыше {{ setting.maxAmountOnline.toString() | amount }} руб. предоставляется в офисе Банка
        </div>
      </div>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block"
                class="button primary block"
                ripple-effect
                (click)="createApplication()"
    >
      Далее
    </ion-button>

    <ion-button expand="block" class="button block primary-light" *ngIf="isApproved"
                ripple-effect
                (click)="abort()">
      Отозвать заявку
    </ion-button>
  </ng-container>


</app-page-wrapper>


